module.exports = __webpack_public_path__ + "media/craftbeer.8b74f4b5.mp4";